import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export function IsmAd() {
  return (
    <section className="ism-ad" data-testid="ism-ad-section">
      <Reveal className="ism-ad-inner">
        <div className="ism-ad-head">
          <span>SPONSORED TRANSMISSION</span>
          <span>CHANNEL 2355 / IZM</span>
        </div>
        <a
          className="ism-ad-body"
          href="https://igotism.com"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="ism-ad-link"
          aria-label="Shop The Ism clothing line at igotism.com"
        >
          <div className="ism-glitch" data-testid="ism-ad-logo">
            <img loading="lazy" src="/assets/ism-logo.png" alt="The Ism clothing line logo" />
            <img loading="lazy" className="ism-glitch-copy ism-glitch-a" src="/assets/ism-logo.png" alt="" aria-hidden="true" />
            <img loading="lazy" className="ism-glitch-copy ism-glitch-b" src="/assets/ism-logo.png" alt="" aria-hidden="true" />
          </div>
          <div className="ism-ad-copy">
            <h2>THE ISM</h2>
            <p>
              Clothing for the ones still standing. Survival-grade apparel engineered for the wasteland of 2355 —
              worn by runners, feared by patrols.
            </p>
            <span className="ism-ad-cta">
              SHOP THE ISM <ArrowUpRight size={16} />
            </span>
          </div>
        </a>
        <div className="ism-ad-foot">
          <span>IGOTISM.COM</span>
          <span>ALL SECTORS — YEAR 2355</span>
        </div>
      </Reveal>
    </section>
  );
}
